import { configureStore } from "@reduxjs/toolkit";
import agentReducer from "../reducers/agentReducer";
import authReducer from "../reducers/authReducer";
import adminReducer from "../reducers/adminReducer";
import pricingPromotionReducer from "../reducers/pricingPromotionReducer";
import supportReducer from "../reducers/supportReducer";
import couponReducer from "../reducers/couponPromotionReducer";
import bannersReducer from "../reducers/bannersReducer";
import aiChatReducer from "../reducers/aiChatSlice";

export default configureStore({
    reducer: {
        agent: agentReducer,
        auth: authReducer,
        admin: adminReducer,
        pricing_promotion: pricingPromotionReducer,
        support: supportReducer,
        coupon_promotion: couponReducer,
        banners: bannersReducer,
        aiChat: aiChatReducer,
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
});
